interface ReadFallbackOptions<T> {
  apiRequest: () => Promise<T>;
  fallbackOnError?: boolean;
  fallbackRequest: () => Promise<T>;
  label: string;
  useMock: boolean;
}

export const withBoardReadFallback = <T>({ apiRequest }: ReadFallbackOptions<T>): Promise<T> => {
  return apiRequest();
};
